import { createFileRoute } from '@tanstack/react-router';
import { CompanyDetailPage } from '@/pages/super-admin/company-detail/CompanyDetailPage';
import { z } from 'zod';

const companyDetailSearchSchema = z.object({
	tab: z.enum(['overview', 'members', 'modules', 'usage', 'record-and-send', 'analytics', 'activity']).optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/companies/$companyId')({
	component: CompanyDetailPage,
	validateSearch: companyDetailSearchSchema,
});
